import { useLocalStorageState } from './useLocalStorageState';

const STORAGE_KEY = 'matchiGridShowAfterWork';
const DEFAULT_VALUE = false;

export const useShowAfterWork = () => {
	const [showAfterWork, setShowAfterWork] = useLocalStorageState(STORAGE_KEY, DEFAULT_VALUE);
	return { showAfterWork, setShowAfterWork };
};
